export function initHeader(){
    const burger = document.querySelector<HTMLButtonElement>(".header-burger");
    const closeButton = document.querySelector<HTMLElement>(".header-main-close");
    const menuLinks = document.querySelectorAll<HTMLAnchorElement>(".header-menu__link");

    const MOBILE_WIDTH = 768;

    const isMobile = () => window.innerWidth < MOBILE_WIDTH;

    // Открыть меню
    burger?.addEventListener("click", () => {
        if (!isMobile()) return;
        document.body.classList.add("menu-active");
    });

    // Закрыть по кнопке
    closeButton?.addEventListener("click", () => {
        if (!isMobile()) return;
        document.body.classList.remove("menu-active");
    });

    // Закрыть по клику на ссылку
    menuLinks.forEach((link) => {
        link.addEventListener("click", () => {
            if (!isMobile()) return;
            document.body.classList.remove("menu-active");
        });
    });
}